import React, {useState, useRef, useEffect, useContext} from 'react';
import styled from "styled-components";
import {FilterContext} from "@providers/filters";
import ButtonBase from "@atoms/button.base";
import RadiusGenerate from "@helpers/radius.generate";
import ModalFiltersHeader from "./components/modal.filters.header";
import CitiesSelection from "./components/cities.selection";
import DistrictsSelection from "./components/districts.selection";
import PriceSelection from "./components/price.selection";
import LoanFilter from "./components/loan.filter";
import HasMediaFilter from "./components/has.media.filter";
import RentSelection from "./components/rent.selection";
import MortgageSelection from "./components/mortgage.selection";
import InfrastructureAreaSelection from "./components/infrastructure.area.selection";
import LandAreaSelection from "./components/land.area.selection";
import BedroomCountFilter from "./components/bedroom.count.filter";
import AgeSelection from "./components/age.selection";
import FloorsSelection from "./components/floors.selection";
import DeedsSelection from "./components/deeds.selection";
import DensityFilter from "./components/density.filter";
import FacilitiesFilter from "./components/facilities.filter";
import DealTypeSelection from "./components/deal.type.selection";
import TypesSelection from "./components/types.selection";
import {isEmpty} from "@helpers/helpers";
import {useWindowSize} from "../../helpers/windows.size";
import VillaTypesSelection from "./components/villa_types_selection";
import {handleFiltersCount} from "../../hooks/filters.manager";
import {handleLockBrowserScroll} from "../../helpers/helpers";
import {getCityById} from "../../../models/district";
import HasPoolFilter from "./components/has_pool_filter";
import HasVideoFilter from "./components/has.video.filter";

var ModalSearchFiltersOpened = false;

function ModalSearchFilters({isBadeSaba, show, setModalFiltersShow}) {
    const windowSize = useWindowSize();
    const FiltersOverlayRef = useRef(null);

    const [selectedCity, setSelectedCity] = useState(null);
    const filters = useContext(FilterContext);
    const {loadings, selected_filters} = filters;
    const selectedFiltersCount = handleFiltersCount(selected_filters);

    useEffect(() => {
        if (show) {
            ModalSearchFiltersOpened = true;
            document.body.classList.add('filter-open');

            handleLockBrowserScroll(true);

            window.history.pushState(null, "", window.location.href);
            window.onpopstate = () => {
                window.history.pushState('back', null, null);

                if (!document.body.classList.contains('selection-open')) {
                    setModalFiltersShow(false)
                }
            };

        } else {
            document.body.classList.remove('filter-open');

            if (!isEmpty(window.onpopstate) && ModalSearchFiltersOpened) {
                ModalSearchFiltersOpened = false;
                window.onpopstate = undefined;
                //window.history.back();
            }

            handleLockBrowserScroll(false);
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [FiltersOverlayRef, show]);

    useEffect(() => {
        if (!isEmpty(selected_filters.city_id)) {
            getCities();

            function getCities() {
                getCityById(selected_filters.city_id).then(city => {
                    setSelectedCity(city)
                }).catch(err => {
                    setTimeout(() => {
                        getCities();
                    }, 1000)
                });
            }
        }
    }, [selected_filters.city_id]);

    function handleClickOutside(event) {
        if (show && FiltersOverlayRef.current && !FiltersOverlayRef.current.contains(event.target)) {
            setModalFiltersShow(false)
        }
    }

    return (
        <CardContainer className={"modal-filters " + (show ? 'show' : '')}>
            <Card className={"modal-filters-card " + (show ? 'show' : '')} ref={FiltersOverlayRef}>
                <ModalFiltersHeader
                    selectedFiltersCount={selectedFiltersCount}
                    setModalFiltersShow={setModalFiltersShow}/>

                <CardBody className="pt-24 pb-32 modal-filter-body">

                    {
                        (windowSize < 992) ?
                            <React.Fragment>
                                <CitiesSelection
                                    name="xs_city_id"
                                    className={"px-24 d-md-none " + (isBadeSaba ? 'd-none' : '')}
                                    items={filters.cities}
                                    selected_filters={selected_filters}
                                    isBadeSaba={isBadeSaba}
                                    showLabelAndSelected
                                />

                                {
                                    (!isEmpty(selectedCity) && selectedCity.type === 'city') ?
                                        <DistrictsSelection
                                            name="xs_district_id"
                                            className="px-24 d-md-none"
                                            items={filters.districts}
                                            loading={(!isEmpty(loadings.districts) && loadings.districts)}
                                            caption_show={2}
                                            showLabelAndSelected
                                            showSelectedItemsInTop
                                        />
                                        : ''
                                }

                                <DealTypeSelection
                                    name="xs_deal_type"
                                    className="px-24 d-md-none"
                                    items={filters.deal_type}
                                    city_id={selected_filters.city_id}
                                    loading={(!isEmpty(loadings.deal_type) && loadings.deal_type)}
                                    typesSelectedItems={filters.types.selected_items}
                                    select_optional
                                    showLabelAndSelected
                                />

                                <TypesSelection
                                    name="xs_type"
                                    className="px-24 d-md-none"
                                    loading={(!isEmpty(loadings.types) && loadings.types)}
                                    items={filters.types}
                                    city_id={!isEmpty(selectedCity) ? selectedCity.id : ''}
                                    caption_show={2}
                                    select_optional
                                    showLabelAndSelected
                                />

                                <VillaTypesSelection
                                    name="xs_villa_type"
                                    className="px-24 d-md-none"
                                    items={filters.villa_type}
                                    select_optional
                                    showLabelAndSelected
                                />
                            </React.Fragment>
                            : ''
                    }

                    <div className="px-24">

                        {
                            (windowSize < 992) ?
                                <React.Fragment>
                                    <PriceSelection
                                        name="xs_price"
                                        className="modal-filter-range d-md-none"
                                        items={filters.price}
                                        showLabelAndSelected
                                    />

                                    <HasMediaFilter
                                        className="border-bottom-gray-200 d-md-none"
                                        items={filters.has_media}
                                    />

                                    <HasVideoFilter
                                        className="border-bottom-gray-200 d-md-none"
                                        items={filters.has_video}
                                    />

                                    <LoanFilter
                                        className="border-bottom-gray-200 d-md-none"
                                        items={filters.loan}
                                    />

                                    <MortgageSelection
                                        name="xs_mortgage"
                                        className="modal-filter-range d-md-none"
                                        items={filters.mortgage}
                                        showLabelAndSelected
                                    />

                                    <RentSelection
                                        name="xs_rent"
                                        className="modal-filter-range d-md-none"
                                        items={filters.rent}
                                        showLabelAndSelected
                                    />
                                </React.Fragment>
                                : ''
                        }


                        <InfrastructureAreaSelection
                            name="xs_infrastructure_area"
                            className="modal-filter-range"
                            items={filters.infrastructure_area}
                            showLabelAndSelected
                        />

                        <LandAreaSelection
                            name="xs_land_area"
                            className="modal-filter-range"
                            items={filters.land_area}
                            showLabelAndSelected
                        />

                        <BedroomCountFilter
                            name="bedroom_count"
                            className="modal-filter-range"
                            items={filters.bedrooms}
                            select_optional
                            showLabelAndSelected
                        />

                        <AgeSelection
                            name="xs_land_area"
                            className="modal-filter-range"
                            items={filters.age}
                            showLabelAndSelected
                        />

                        <FloorsSelection
                            name="xs_floors"
                            className="modal-filter-range"
                            items={filters.floors}
                            caption_show={2}
                            showLabelAndSelected
                        />

                        <DeedsSelection
                            name="xs_deeds"
                            className="modal-filter-range"
                            items={filters.deeds}
                            caption_show={2}
                            showLabelAndSelected
                        />

                        <DensityFilter
                            name="bedroom_count"
                            className="modal-filter-range"
                            items={filters.densities}
                            showLabelAndSelected
                            caption_show={2}
                        />

                        <FacilitiesFilter
                            name="facilities"
                            className="modal-filter-range"
                            items={filters.facilities}
                            showLabelAndSelected
                            caption_show={2}
                            select_optional
                        />

                        {
                            (filters.has_pool.show) ?
                                <HasPoolFilter
                                    className="border-bottom-gray-200"
                                    items={filters.has_pool}
                                />
                                : ''
                        }

                    </div>

                </CardBody>

                <CardFooter>
                    < ButtonBase onClick={() => setModalFiltersShow(false)} color="secondary" block>
                        مشاهده نتایج
                    </ButtonBase>
                </CardFooter>
            </Card>
        </CardContainer>
    )
}

export default ModalSearchFilters;

// ******
// style
// ******

const CardContainer = styled.div`
  position: fixed !important;
  top: calc(100% + 200px);
  display: flex;
  justify-content: center;
  right: 0;
  width: 100%;
  height: 100% !important;
  max-width: none !important;
  max-height: none !important;
  color: ${props => props.theme.black};
  background-color: rgba(0, 0, 0, .55);
  z-index: 5049;
  opacity: 0;
  visibility: hidden;

  &.show {
    top: 0;
    opacity: 1;
    visibility: visible;
  }

  @media (max-width: ${props => props.theme.screenXsMax}) {
    background-color: transparent;
  }


  .modal-filter-pl-32 {
    padding-left: 32px;
  }
`;

const Card = styled.div`
  position: fixed !important;
  top: 100%;
  bottom: auto;
  transition: top 0.4s cubic-bezier(0.175, 0.885, 0.35, 1), opacity 0.1s linear;
  width: 420px;
  height: calc(100% - 96px);
  background-color: ${props => props.theme.white};
  margin: auto;
  ${RadiusGenerate('16px')};

  &.show {
    top: 48px;
  }

  @media (max-width: ${props => props.theme.screenXsMax}) {
    width: 100%;
    height: 100%;
    border-radius: 0;
    top: 100%;
    bottom: auto;

    &.show {
      top: 0;
      bottom: 0;
    }
  }
`;

export const CardBody = styled.div`
  position: static;
  height: calc(100% - 137px) !important;
  overflow-y: auto;

  .form-group {
    margin-bottom: 0;
  }

  @media (max-width: ${props => props.theme.screenXsMax}) {
    .selection-open & {
      overflow: hidden;
    }
  }
`;

const CardFooter = styled.div`
  padding: 16px 24px;
  border-top: 1px solid transparent;
  width: 100%;
`;
